module.exports = __webpack_public_path__ + "static/img/visibility.1afef337.svg";